import { X } from '@phosphor-icons/react'
import { LinkExternalIcon } from '@primer/octicons-react'
import React, { useContext, useState } from 'react'

import DownvoteButton from '@/components/posts/DownvoteButton'
import UpvoteButton from '@/components/posts/UpvoteButton'
import Badge from '@/components/shared/ui/Badge'
import Button from '@/components/shared/ui/Button'
import UnstyledLink from '@/components/shared/ui/Links/UnstyledLink'
import HNContext from '@/context/HNContext'
import { objectHasProperty } from '@/lib/helpers/dataHelpers'
import { getPostBucket } from '@/lib/helpers/modules/postHelper'
import type { IOrganizationSetting } from '@/types/organization'
import type { IPost } from '@/types/post'

interface IPropTypes {
  post: IPost
  onRemove: (post: IPost) => void
  readonly?: boolean
}
export default function KanbanTaggedPost({
  post: _post,
  onRemove,
  readonly,
}: IPropTypes) {
  const [post, setPost] = useState(_post)
  const { organizationSetting, buckets = [] } = useContext(HNContext)
  const { downvotes } = organizationSetting as IOrganizationSetting
  const bucket = getPostBucket(post, buckets)

  return (
    <li className='group w-full list-none overflow-hidden bg-snow px-4 py-2 transition'>
      <span className='flex items-center truncate text-left text-sm text-gray11 '>
        {post.title}
      </span>
      <div className='mt-3 flex items-center justify-between overflow-hidden'>
        <div className='flex space-x-1'>
          <UpvoteButton
            size='sm'
            post={post}
            onUpdate={(newPost) => setPost({ ...newPost, slug: _post.slug })}
          />
          {downvotes &&
            objectHasProperty(post, 'downvotes_count_number') &&
            post.can_downvote && (
              <DownvoteButton
                size='sm'
                post={post}
                onUpdate={(newPost) =>
                  setPost({ ...newPost, slug: _post.slug })
                }
              />
            )}
        </div>
        <div className='flex items-center space-x-2'>
          <Badge size='xxs' value={bucket?.display_name} />
          <UnstyledLink href={`/p/${post.slug}`} target='_blank'>
            <LinkExternalIcon className='h-3 w-3' />
          </UnstyledLink>
          {!readonly ? (
            <Button
              fab
              type='button'
              onClick={() => onRemove(post)}
              variant='secondary'
              size='xxs'
            >
              <X weight='bold' className='h-3 w-3 shrink-0 text-red9' />
            </Button>
          ) : null}
        </div>
      </div>
    </li>
  )
}
